import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Button, FormLabel } from "@mui/material";
import { FormGroup, FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import { getKeyImageUrl } from "../../Functions/APIservice/useStorage";

type KeyImageManagementFormsType = {
  KeyImageDatalist: {
    path: string;
    name: number;
    description: string;
    share: boolean;
  }[];
  CatalogueId: string;
  // getContentsData:(value:string,name:string)=>void
  getKeyImageDatalist: (
    value: {
      path: string;
      name: number;
      description: string;
      share: boolean;
    }[]
  ) => void;
};

export default function KeyImageManagementForms(
  props: KeyImageManagementFormsType
) {
  const [keyImageDatalist, setKeyImageDatalist] = React.useState(
    props.KeyImageDatalist
  );
  const [update, setUpdate] = React.useState(false);
  const [imageRowDatas, setImageRowDatas] = React.useState<string[]>([]);
  const [showImageUrl, setShowImageUrl] = React.useState<{
    url: string;
    index: number | null;
  }>({ url: "", index: null });
  const [open, setOpen] = React.useState(false);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    p: 4,
  };

  const handleOpen = (path: string, index: number) => {
    setShowImageUrl({ url: path, index: index });
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    // Convert 'share' to boolean
    console.log(keyImageDatalist)
    const updatedKeyImageDatalist = keyImageDatalist.map((keyImage) => ({
      ...keyImage,
      share: Boolean(keyImage.share),
    }));
    setKeyImageDatalist(updatedKeyImageDatalist);
    props.getKeyImageDatalist(updatedKeyImageDatalist);
  }, []);

  React.useEffect(() => {
    const fetchKeyImages = async () => {
      const keyImageDatasPromises: Promise<string>[] = keyImageDatalist.map(
        async (KeyImageData) => {
          const urlResult = await getKeyImageUrl(
            `gs://mnes-mnist-imagestudy.appspot.com/KeyImage/${props.CatalogueId}/${KeyImageData.path}`
          );
          return urlResult;
        }
      );

      Promise.all(keyImageDatasPromises).then((result) =>
        setImageRowDatas(result)
      );
    };

    fetchKeyImages();
  }, [keyImageDatalist]);

  return (
    <div>
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          キー画像情報
        </Typography>
        <Grid container spacing={3}>
          {keyImageDatalist.map((keyImage, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={12}
                display={{ sm: "flex", xs: "grid" }}
                gap={3}
              >
                <Grid>
                  {imageRowDatas.length > 0 ? (
                    //     <Card key={keyImage.path} sx={{ maxWidth: 150, marginBottom: 1 }}>
                    //     <CardMedia
                    //         sx={{ height: 150 }}
                    //         image={imageRowDatas[index]}
                    //         onClick={()=>handleOpen(keyImage.path)}
                    //     />
                    // </Card>
                    <Box
                      sx={{ "&:hover": { cursor: "pointer" } }}
                      onClick={() => handleOpen(imageRowDatas[index], index)}
                    >
                      <img
                        src={imageRowDatas[index]}
                        style={{ width: "auto", height: "150px" }}
                      />
                    </Box>
                  ) : (
                    <div></div>
                  )}
                </Grid>
                <FormControl fullWidth>
                  <TextField
                    id="filled-read-only-input"
                    label="注釈"
                    defaultValue={keyImage.description}
                    multiline
                    rows={5}
                    onChange={(event) => {
                      var olddata = keyImageDatalist;
                      olddata[index]["description"] = event.target.value;
                      setKeyImageDatalist(olddata);
                      props.getKeyImageDatalist(olddata);
                    }}
                  />
                </FormControl>
                <FormControl fullWidth style={{ width: "50%" }}>
                  <InputLabel id="demo-simple-select-label">公開</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Number(keyImage.share)}
                    label="Share"
                    onChange={(event: SelectChangeEvent<number>) => {
                    //   var olddata = [...keyImageDatalist];
                    //   olddata[index]["share"] = Boolean(
                    //     event.target.value as number
                    //   );
                    //   setKeyImageDatalist(olddata);
                    //   props.getKeyImageDatalist(olddata);
                      setKeyImageDatalist((prevState) => {
                        const olddata = [...prevState];
                        olddata[index]["share"] = Boolean(
                          event.target.value as number
                        );
                        props.getKeyImageDatalist(olddata);
                        console.log("keyImageDatalist: ", keyImageDatalist)
                        console.log("olddata: ", olddata)
                        return olddata;
                      });
                      setUpdate(!update);
                    }}
                  >
                    <MenuItem value={0}>非公開</MenuItem>
                    <MenuItem value={1}>公開</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            );
          })}
        </Grid>
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogContent>
            <Card sx={{ display: "flex" }}>
              <CardMedia
                component="img"
                sx={{ height: 400, width: "auto", objectFit: "contain" }}
                image={showImageUrl.url}
                alt="KeyImage"
              />
              <Box sx={{ minWidth: 300 }}>
                <CardContent sx={{ minWidth: 300 }}>
                  <Typography component="div" variant="h6">
                    {showImageUrl.index !== null
                      ? keyImageDatalist[showImageUrl.index].description
                      : ""}
                  </Typography>
                </CardContent>
                <Box
                  sx={{ display: "flex", alignItems: "center", pl: 1, pb: 1 }}
                ></Box>
              </Box>
            </Card>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  );
}
